import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../../shared/redux/reducers';
import { getUserByEmail } from '../../../../shared/services/data/user.data';
import { isErrorInfo } from '../../../../shared/interfaces/error-info.interface';
import { getModuleName } from '../../../shared/services/reservations-dashboard.data';

const greeting = () => {
  const hour = new Date().getHours();
  return hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';
};

const today = () =>
  new Date().toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

type GreetingProps = {
  email: string;
  actions?: React.ReactNode;
};

const DashboardGreetingComponent = ({ email, actions }: GreetingProps) => {
  const [firstName, setFirstName] = useState('');

  useEffect(() => {
    if (!email) return;
    let cancelled = false;
    getUserByEmail(email, getModuleName()).then((user) => {
      if (!cancelled && !isErrorInfo(user) && user.name) {
        setFirstName(user.name.split(' ')[0]);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [email]);

  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div>
        <h1 className="m-0 text-[clamp(26px,2.6vw,40px)] font-gilroy-bold leading-tight text-neutral-500">
          {greeting()}
          {firstName && `, ${firstName}`}
        </h1>
        <p className="m-0 mt-2 text-[15px] tabular-nums text-neutral-300">{today()}</p>
      </div>
      {actions}
    </div>
  );
};

export const DashboardGreeting = connect((state: RootState) => ({ email: state.auth.email || '' }))(
  DashboardGreetingComponent
);
